export default __webpack_public_path__ + "static/media/case1-1.2e611b19.png";